<script>
	import { createEventDispatcher } from "svelte";

	import lookups from "../stores/lookupStore";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import TextInput from "./TextInput.svelte";
	import Select from "./Select.svelte";
	import RelativeDiagnoses from "./RelativeDiagnoses.svelte";

	export let disabled = null;
	export let numberOfRelatives = 1;
	export let diagnosisType = null;
	export let relative;
	export let relativeIndex;

	const dispatcher = createEventDispatcher();

	const deleteRelative = () => {
		dispatcher("delete-relative");
	};
</script>

<div class="relative">
	<FormRow class="mt-2">
		<FormColumn cols="6">
			<TextInput required {disabled} label="Relative name" bind:value={relative.relativeName} />
		</FormColumn>
		<FormColumn cols="6">
			<Select
				required
				{disabled}
				label="Relation"
				bind:value={relative.relativeTypeId}
				optionList={$lookups.relativeType}
				textProperty="lookupName"
				valueProperty="id"
			/>
		</FormColumn>
	</FormRow>

	<RelativeDiagnoses {relativeIndex} bind:diagnoses={relative.relativeDiagnoses} {diagnosisType} {disabled} />

	{#if numberOfRelatives > 1}
		<div class="confirmation-hide">
			<button on:click|preventDefault={deleteRelative} class="delete" title="Delete relative">
				<i class="fas fa-trash"></i>
			</button>
		</div>
	{/if}
</div>

<style>
	.relative {
		position: relative;
		margin-right: 40px;
	}

	.delete {
		border: none;
		outline: none;
		background-color: transparent;
		position: absolute;
		top: 33px;
		right: -36px;
		font-size: 1.1rem;
		color: var(--color-primary);
	}
</style>
